export function isNotNull(value) {
    return value !== null;
}
export function isMesh(object) {
    return object.isMesh === true;
}
export function isLineSegments(object) {
    return object.isLineSegments === true;
}
export function isObject3D(object) {
    return object && object.isObject3D;
}
export function isGroup(object) {
    return object && object.isGroup;
}
